var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstallation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.601562,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#26B0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6298 14.2856H40.2108C40.5778 14.2856 40.8198 14.6679 40.6627 14.9996L34.9145 27.1428H42.6791C43.1205 27.1428 43.3453 27.673 43.0386 27.9903L24.3872 47.2849C24.0355 47.6486 23.428 47.3199 23.5401 46.8265L26.5762 33.4679C26.6472 33.1553 26.4099 32.8577 26.0896 32.8571C26.0893 32.8571 26.0889 32.8571 26.0886 32.8571H18.872L18.8716 32.8571C18.5207 32.8571 18.2789 32.5051 18.4049 32.1776L25.1631 14.6062C25.2374 14.4131 25.4229 14.2856 25.6298 14.2856Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstallation);
export default __webpack_public_path__ + "static/media/installation.62703d28185f8ddcc9b3a6370ba8a3f7.svg";
export { ForwardRef as ReactComponent };